// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"a6c6f53b","34":"ac5e3d36","146":"1c9405fd","164":"44ee03dd","278":"9b933ea9","342":"bafaeaa2","477":"099342c1","486":"d52919e7","534":"5918d4ec","619":"3c87f216","908":"85963b54","954":"6a992a4f"}[chunkId] + ".chunk.js";
};